import React from "react";
import { ResponsivePie } from "@nivo/pie";

function PieChart({ rangeSale, sale, profit, loss }) {
  let selectedSale = 0;
  if (rangeSale.length > 0) {
    selectedSale = rangeSale.reduce((prev, cur) => prev + parseInt(cur.y), 0);
  }

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <ResponsivePie
        data={[
          {
            id: "profit",
            label: "Profit",
            value: profit || 0,
            color: "hsl(27, 70%, 50%)",
          },
          {
            id: "sale",
            label: "Sale",
            value: sale ? sale : 0,
            color: "hsl(35, 70%, 50%)",
          },
          {
            id: "loss",
            label: "Loss",
            value: Math.abs(loss) || 0,
            color: "hsl(35, 70%, 50%)",
          },
        ]}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={["#4CAF50", "#757575", "#f82d2d"]}
        index="id"
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={16}
        radialLabelsLinkHorizontalLength={24}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: "color" }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#ffffff"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        defs={[]}
        fill={[]}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            translateY: 56,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: "#999",
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
}

export default PieChart;
